import React from 'react'
import { Button } from 'antd'
import styled from 'styled-components'
import SuccessIcon from '../../asserts/icon/questionnaire/ic_questionnaire_pre_medical_success.svg'
import { OnboardingHeader } from './style'

const Container = styled.div`
  width: 400px;
  text-align: center;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  h1 {
    color: #323f4a;
    font-size: 36px;
    margin-bottom: 36px;
  }
  img {
    margin-bottom: 36px;
  }
  .content {
    color: #52606c;
    font-size: 16px;
    font-weight: 400;
    letter-spacing: 0.3px;
    line-height: 150%;
  }
  button {
    width: 229px;
    height: 48px;
    margin-top: 20px;
  }
`

export default function After2FA(props) {
  const { history } = props
  return (
    <div className="main-container">
      <OnboardingHeader />
      <Container>
        <h1>Success</h1>
        <img src={SuccessIcon} alt="completed" />
        <div className="content">
          <p>
            Thank you for joining Apeiron. We are excited to welcome you as a
            new member!
          </p>
          <p>
            Your Apeiron concierge will reach out to assist with onboarding and
            scheduling.
          </p>
          <p>
            In the meantime, feel free to begin your onboarding questionnaires
            so we can get to know more about you and help you take full
            advantage of working with our Apeiron team of experts.
          </p>
          <Button
            size="large"
            type="primary"
            onClick={() => history.push(history.push('/onboarding/ready'))}
          >
            DONT IT NOW
          </Button>
        </div>
      </Container>
    </div>
  )
}
